<template>
    <div class="form-check form-check-filtros">
        <input
            class="form-check-input"
            type="checkbox"
            :value="inputValue"
            v-model="model"
        />
        <label class="form-check-label">
            {{ label }}
        </label>
    </div>
</template>

<script>
export default {
    name: "RadioCheckbox",
    props: {
        label: String,
        value: Array,
        inputValue: [Number, String],
    },
    computed: {
        model: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            },
        },
    },
};
</script>
